import script from "./OperatorApplicationForwardButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationForwardButton.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationForwardButton.vue?vue&type=style&index=0&id=cfb2437c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfb2437c"]])

export default __exports__